import React, { Component } from "react";
import styled from "styled-components";
import { canUseDOM } from "exenv";

if (canUseDOM) {
	const $script = require("scriptjs");
	$script("https://tithe.ly/widget/v3/give.js?3", "tithely-embed");
}

export default class Tithely extends Component {
	componentDidMount() {
		if (canUseDOM) {
			const $script = require("scriptjs");
			$script.ready("tithely-embed", () => {
				var tw = create_tithely_widget();
			});
		}
	}

	render() {
		return (
			<TithelyButton className="tithely-give-btn" data-church-id="367990">
				Donate Online
			</TithelyButton>
		);
	}
}

const TithelyButton = styled.button`
	color: white;
	background: linear-gradient(45deg, #136163, #05a143);
	padding: 1rem 4rem;
	border-radius: 10px;
	font-size: 1.2rem;
	text-transform: uppercase;
	font-weight: bold;
	box-shadow: 0 5px 10px rgba(4, 135, 56, 0.3);
	transition: 300ms;
	outline: none;
	cursor: pointer;

	&:hover {
		box-shadow: 0 10px 20px rgba(4, 135, 56, 0.3);
		transform: translateY(-0.5rem);
	}

	@media screen and (max-width: 1024px) {
		padding: 0.75rem 2rem;
		font-size: 1rem;
	}
`;



// WEBPACK FOOTER //
// ./src/components/Tithely.jsx